import { render, staticRenderFns } from "./PhoneField.form-builder.vue?vue&type=template&id=1f241eef&"
import script from "./PhoneField.form-builder.vue?vue&type=script&lang=js&"
export * from "./PhoneField.form-builder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports